<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';
</script>

<style>
    .non-default {
        color: var(--color-brand);
        padding: 0 1rem;
    }
</style>

<span class="checkmark non-default">
    <Icon name="check-12" ariaHidden />
</span>
